interface DisplayText {
    header: string
    line1: string
    line2: string
    footer: string
}

interface HowText {
  register: string
  confirm: string
  enjoy: string
}

interface FAQText {
    question: string
    answer: string
}

const pfm: DisplayText = {
    header: "Register for invitations to free screenings near you",
    line1: "Wouldn't you love to see a movie before it's released - for free? At Preview Free Movies, you can do just that!",
    line2: "Simply fill in your information below to sign up, and the next time we're holding a movie screening in your area we'll email you an invitation.",
    footer: "It's that easy!"
}

const gaming: DisplayText = {
    header: "Register to see and play games early!",
    line1: "Get rewarded to preview and play pre-release games. Yes, it's true, no, there's no catch.",
    line2: "Enter your registration information through the link below and we'll automatically invite you to any projects you qualify for.",
    footer: "It's that easy!"
}

const pfmHow: HowText = {
    register: "Start by registering on the homepage. Once registered, you will start to receive invitations to events when they are scheduled in your area!",
    confirm: "Once you receive your invitation, please follow the instructions and let us know that you are coming!",
    enjoy: "That’s it!  Bring your confirmation email to the screening either by printing it out or having it ready on your phone at the event, and enjoy the show!"
}

const gamingHow: HowText = {
  register: "Register on the homepage and get invited to exclusive gaming events in your area!",
  confirm: "Confirm the invitation and let us know that you are coming!",
  enjoy: "That’s it! Bring your confirmation email to the event. Get rewarded to preview and play pre-release games!"
}

const pfmFaq: FAQText[] = [
    {
        question: 'Can I bring someone over or under the age group listed on my invitation?',
        answer: `Unfortunately, only guests within the listed age range on your invitation may attend.`
    },
    {
        question: 'Am I allowed to change my guest after I’ve confirmed for a screening?',
        answer: `Yes, as long as your new guest is in the stated age range you can update your confirmation by logging into your Preview Free Movies account. You simply need to bring them to the event along with your invitation and printed confirmation.`
    },
    {
        question: 'What do I do if I confirmed but never received my email confirmation?',
        answer: `Please check your junk mail folder to ensure that your confirmation was not sent there by accident. You can also log into your Preview Free Movies account and under “My Screenings” to resend your confirmation.`
    },
    {
        question: 'I don’t have a printer to print my confirmation, can I still attend?',
        answer: `Yes, if you do not have a printer, you can show your confirmation on your phone at check in. Please note after checking in you will need to return any device with a camera (including smartphones) back to your car.`
    },
    {
        question: 'If I am waitlisted, how do I know if new seats become available for the event?',
        answer: `If new seats become available, we will email you a new invitation to the email address you initially registered with.`
    },
    {
        question: 'Does my confirmation mean I’m guaranteed a seat?',
        answer: `Please keep in mind that no seats are guaranteed, but you will have the best chance of getting seated if you arrive at least one hour before show time.`
    },
    {
        question: 'My information has changed since registering, how can I update my profile?',
        answer: `To update your personal information please log into your Preview Free Movies account and go to “My Account.”`
    },
    {
        question: 'Are cell phones allowed into the theater?',
        answer: `Unfortunately any device with a camera or lens, including smartphones or tablets, are not permitted into the screening. If you need your device to show your confirmation, you’ll have an opportunity to return it to your vehicle or check it with security after you’ve checked-in for the event. Courtesy camera phone check is available at most events but is not guaranteed. Please note that Preview Free Movies does not assume any responsibility for devices that may be lost or damaged while being held.`
    },
    {
        question: 'How many guests am I allowed to bring based on the confirmation page?',
        answer: `The number of guests allowed varies from event to event. The confirmation page is good for you and all the guests you sign up with at the time of confirmation.`
    },
    // {
    //   question: 'How do I provide feedback about my experience?',
    //   answer: `For any questions or concerns about:
    //   <ul>
    //     <li>An event, you may reach us at: <a href="mailto:inquiries&#64;previewfreemovies.com">inquiries&#64;previewfreemovies.com</a></li>
    //     <li>An event reward, you may reach us at: <a href="mailto:rewards&#64;previewfreemovies.com">rewards&#64;previewfreemovies.com</a></li>
    //     <li>Your data or data privacy, you may reach us at: <a href="mailto:dataprivacy&#64;previewfreemovies.com">dataprivacy&#64;previewfreemovies.com</a> or leave a message at (888) 502-3665</li>
    //   </ul>`
    // }
]

const gamingFaq: FAQText[] = [
  {
    question: "Is this legit?",
    answer: "Yes! Patch Notes is a real market research group focused on video games. We conduct research for developers and publishers to improve their games through player feedback. You’ll get rewarded for your time. And as a gamer, the sessions are fun and engaging."
  },
  {
    question: "How do I sign up?",
    answer: "Fill out our <a href='/register'>sign-up form</a> to join our participant panel. If you qualify, we’ll notify you when relevant studies become available."
  },
  {
    question: "Do I have to like every game I test?",
    answer: "Nope! We encourage honest feedback. That’s how games get better."
  },
  {
    question: "How does the research process work?",
    answer: "<ul class='faq-list'><li>Sign up to join our research panel.</li><li>Get invited via email or SMS when a new study matches your profile.</li><li>Apply for each opportunity you're interested in.</li><li>Complete a short phone screen (if needed) to confirm eligibility.</li><li>Join the session and share your feedback.</li><li>Receive your reward within a week after the session.</li></ul>"
  },
  {
    question: "What types of research do you run?",
    answer: "<b>Playtests:</b> Try unreleased games or early builds and give feedback.<br><b>Concept testing:</b> Share your opinions on game ideas or features.<br><b>Surveys:</b> Quick polls about your preferences or gaming habits."
  },
  {
    question: "What do I do if I confirmed but never received my email confirmation?",
    answer: "Please check your junk mail folder to ensure that your confirmation was not sent there by accident. You can also log into your Patch Notes account and under “My Studies” select to resend your confirmation."
  },
  {
    question: "My information has changed since registering; how can I update my profile?",
    answer: "To update your personal information please log into your Patch Notes account and go to “My Account.”"
  }
]

export const branding = {
  pfm: 'Preview Free Movies',
  gaming: 'Patch Notes'
}

export const shortBranding = {
  pfm: 'PFM',
  gaming: 'PN'
}

export const domain = {
  pfm: 'PreviewFreeMovies.com',
  gaming: 'PatchNotesGaming.com'
}

export const brandedText = { pfm, gaming }

export const howText = { pfm: pfmHow, gaming: gamingHow }

export const faqText = { pfm: pfmFaq, gaming: gamingFaq }

export const eventType = {
  pfm: 'Screening',
  gaming: 'Event'
}
